/* BackToTop — floating button that appears after the user scrolls past 600px.
 * Lives at bottom-right and smooth-scrolls back to the top of the page.
 *
 * Reusable across the public marketing pages (LandingPageDark, FeaturesPage,
 * Privacy, Terms). Uses Tailwind only — no external deps.
 */
import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

export default function BackToTop({ threshold = 600 }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      aria-label="Back to top"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      data-testid="back-to-top-btn"
      className={[
        'fixed bottom-6 right-6 z-40 w-11 h-11 rounded-full',
        'bg-white/10 backdrop-blur-md border border-white/20',
        'text-white shadow-lg shadow-black/40',
        'hover:bg-white/20 hover:scale-105 transition-all duration-200',
        'flex items-center justify-center',
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none',
      ].join(' ')}
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
